export const downloadFile = (url: string, fileName: string): void => {
    if (!url) {
        console.error('The URL is required for downloading a file.');
        return;
    }

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || 'download';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
